import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/database';
import 'firebase/compat/storage';

const firebaseConfig = {
    apiKey: 'AIzaSyALCUSFYEf9YIn48oZ0EEn6dyp_F2STSYE',
    authDomain: 'study-go-8966e.firebaseapp.com',
    databaseURL: 'https://study-go-8966e-default-rtdb.firebaseio.com',
    projectId: 'study-go-8966e',
    storageBucket: 'study-go-8966e.appspot.com',
    messagingSenderId: '565225622382',
    appId: '1:565225622382:web:f37331923bf2f57a14cf7f',
    measurementId: 'G-SP3PJ4CMEV',
};
// Initialize Firebase
const firebaseApp = firebase.initializeApp(firebaseConfig);
const firebaseAuth = firebaseApp.auth();
const firebaseDb = firebaseApp.database();
const firebaseSt = firebaseApp.storage();

export { firebaseAuth, firebaseDb, firebaseSt };

